<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-toolbar flat>
                <v-toolbar-title>Summary Area Manager</v-toolbar-title>
                <v-divider class="mx-4" inset vertical />
                <v-spacer />
                <v-btn depressed color="green" class="d-inline ms-2 white--text" @click="export2xls">Export to XLS</v-btn>
            </v-toolbar>
            <div class="mt-3">
                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">Start Date</v-col>
                    <v-col lg="2" md="3" sm="8" cols="4">
                        <v-menu v-model="startDateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs}">
                                <v-text-field v-model="start_date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                            </template>
                            <v-date-picker v-model="start_date" @change="handelChangeStartDate"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col lg="2" md="3" sm="4" cols="4">Volume</v-col>
                    <v-col lg="2" md="3" sm="8" cols="8">
                        <v-select outlined dense hide-details="auto" :items="bottles" item-value="code" item-text="description" v-model="selectedSize" class="compact-form" @change="handleChangeVolume"></v-select>
                    </v-col>
                </v-row>
                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">End Date</v-col>
                    <v-col lg="2" md="3" sm="8" cols="4">
                        <v-menu v-model="endDateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs}">
                                <v-text-field v-model="end_date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                            </template>
                            <v-date-picker v-model="end_date" @change="handelChangeEndDate"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col lg="2" md="3" sm="4" cols="4">Tipe</v-col>
                    <v-col lg="2" md="3" sm="8" cols="8">
                        <v-select outlined dense hide-details="auto" :items="typeReports" item-value="code" item-text="name" v-model="selectedType" class="compact-form" @change="handleChangeTypeReport"></v-select>
                    </v-col>
                </v-row>
                <v-row class="mx-5" v-if="group != 'OP'">
                    <v-col lg="2" md="3" sm="4" cols="4">Filter Area (Ops)</v-col>
                    <v-col lg="2" md="3" sm="8" cols="4">
                        <v-select outlined dense hide-details="auto" :items="users" item-value="username" item-text="fullname" v-model="selectedUser" class="compact-form"></v-select>
                    </v-col>
                </v-row>
                <v-row class="compact-form my-2 mx-1">
                    <v-col>
                        <v-card outlined>
                            <v-skeleton-loader v-if="isLoading" type="table-tbody">
                            </v-skeleton-loader>
                            <v-simple-table v-else ref="tabelExport">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th></th>
                                            <th v-for="(outlet, i) in filteredOutlets" :key="i" class="text-no-wrap text-center">
                                                {{ getCategoryName(outlet.outlet_category_code) }}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th></th>
                                            <th>Total</th>
                                            <th v-for="(outlet, i) in filteredOutlets" :key="i" class="text-no-wrap">
                                                {{ outlet.name }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(date, idx) in dates" :key="idx">
                                            <td class="text-no-wrap">{{ date.day_name }}, {{ date.date_format }}</td>
                                            <td class="text-center">{{ getTotal(date.date) }}</td>
                                            <td class="text-center" v-for="(outlet, idxo) in filteredOutlets" :key="idxo"
                                                :class="{'red-cell': cssTokoTutup(outlet, date) }">
                                                {{ getQty(outlet.code, date.date) }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </div>
</template>

<script>
import { utils, writeFileXLSX } from 'xlsx';

export default {
    data() {
        return {
            start_date: '',
            startDateMenu: false,
            end_date: '',
            endDateMenu: false,
            categories: [],
            outlets: [],
            items: [],
            users: [],
            group: '',
            dates: [],
            selectedSize: '490',
            isLoading: false,
            bottles: [],
            selectedType: 'sales_actual',
            selectedUser: '',
            typeReports: [
                { code: 'sales_actual', name: 'AKTUAL JUAL' },
                { code: 'stock_in_all', name: 'STOCK IN ALL' },
                { code: 'stock_in_polim', name: 'STOCK IN POLIM' },
                { code: 'retur', name: 'RETUR HARIAN' },
                { code: 'transfer_in', name: 'TRANSFER IN' },
                { code: 'transfer_out', name: 'TRANSFER OUT' },
                { code: 'sisa_stok', name: 'SISA STOK' },
                { code: 'stock_in', name: 'STOCK IN' },
                { code: 'sales_target', name: 'TARGET SALES' },
                { code: 'sales_tomorrow', name: 'JUAL BESOK TERAKHIR' },
                { code: 'cautions', name: 'HATI-HATI' },
                { code: 'new_arrival', name: 'BARU DATANG' },
                { code: 'frozen', name: 'BARANG BEKU' },
            ],
        }
    },

    created() {
        this.getBottles();
        this.getCategories();
        this.getOutlets();
        this.fetchData();
    },

    computed: {
        filteredOutlets() {
            if (this.selectedUser) {
                return this.outlets.filter(o => o.operational_team_code == this.selectedUser);
            } else {
                return this.outlets;
            }
        },
    },

    methods: {
        getBottles() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.bottles = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                });
        },
        async getCategories() {
            let response = await this.$store.dispatch('outletcategory/getObjs');
            if (response.data.status == 'success') {
                this.categories = response.data.data;
            }
        },
        getCategoryName(code) {
            const category = this.categories.find(c => c.code === code);
            if (category) {
                return category.name;
            }
            return '';
        },
        cssTokoTutup(outlet, date) {
            let result = false;

            const weekdays = outlet.weekdays_hours_percent[date.dow];
            if (weekdays) {
                if (weekdays.min_stock == 0 && weekdays.max_stock == 0) {
                    result = true;
                }
            }

            return result;
        },
        async getOutlets() {
            let response = await this.$store.dispatch('outlet/getObjs');
            if (response.data.status == 'success') {
                this.outlets = response.data.data
            }
        },
        handelChangeStartDate() {
            this.fetchData();
        },
        handelChangeEndDate() {
            this.fetchData();
        },
        handleChangeVolume() {
            this.fetchData();
        },
        handleChangeTypeReport() {
            // this.fetchData();
        },
        async fetchData() {
            this.isLoading = true;

            try {
                const response = (await this.$store.dispatch('getObjs', {
                    apidomain: `report-summary-area-manager`,
                    parameter: `?start_date=${this.start_date}&end_date=${this.end_date}&size=${this.selectedSize}`,
                }));

                const data = response.data.data;
                this.start_date = data.start_date;
                this.end_date = data.end_date;
                this.dates = data.dates;
                this.items = data.items;
                // this.users = data.users;
                this.users = [{'username': '', 'fullname': 'All'} , ...(data.users || [])];
                this.group = data.group;
            } catch (error) {
                console.log('Error fetching report summary area manager : ', error);
            } finally {
                this.isLoading = false;
            }
        },
        getTotal(date) {
            let total = 0;
            this.filteredOutlets.forEach(outlet => {
                total += Number(this.getQty(outlet.code, date), 0);
            })
            return total;
        },
        getQty(outlet_code, date) {
            const item = this.items.find(i => i.outlet_code === outlet_code && i.sales_date === date);

            if (!item) return '';

            if (Object.prototype.hasOwnProperty.call(item, this.selectedType)) {
                const value = item[this.selectedType];
                return value === 0 ? '' : value;
            }

            return '';
        },
        export2xls() {
            const wb = utils.table_to_book(this.$refs.tabelExport.$el.firstChild.firstChild);
            
            const typeMap = {
                sales_actual: 'Aktual-Jual',
                stock_in_all: 'Stock-In-All',
                stock_in_polim: 'Stock-In-Polim',
                retur: 'Retur-Harian',
                transfer_in: 'Transfer-In',
                transfer_out: 'Transfer-Out',
                sisa_stok: 'Sisa-Stok',
                stock_in: 'Stock-In',
                sales_target: 'Target-Sales'
            };
            
            const label = typeMap[this.selectedType] || 'Summary';
            const fileName = `${label}-Area-Manager.xlsx`;

            writeFileXLSX(wb, fileName);
        },
    }
}
</script>

<style scoped>
table, th, td {
  border: 1px solid grey;
  border-collapse: collapse;
}

.red-cell {
  background-color: #FF7F7F;
}
</style>